<template>
  <v-container
    fluid
    class="pa-0 login-background"
    :style="{ backgroundImage: 'url(' + $cdnEndpoint + 'img/login/login_background_cloudsign_review.jpg)' }"
    style="text-align: center;"
  >
    <div class="content-area">
      <Announcement class="mb-5" :announcement="announcementData" />
      <v-layout column class="bg-color-white login-form-area">
        <v-layout align-center column justify-centers>
          <WarningText :is-show="!isAllowedBrowserAccess" :warning-text="browserEnvironmentAlert" />
          <v-flex class="mt-5 mb-1">
            <LabelEmailInput id="email" v-model="email" v-on:keyup.enter.native="valid ? submitLogin() : false" style="margin-left: 7px;" />
            <LabelPasswordInput
              id="password"
              v-model="password"
              v-on:keyup.enter.native="valid ? submitLogin() : false"
              style="margin-left: 7px;"
            />
            <LinkLabel @click.native="passwordReset">パスワードをお忘れですか？</LinkLabel>
            <Button
              :width="313"
              :height="40"
              primary
              :disabled="!valid"
              :loading="loginLoading"
              @click.native="valid ? submitLogin() : false"
              >ログイン</Button
            >
          </v-flex>
        </v-layout>
        <v-layout justify-end class="mr-3 mb-3">
          <PoweredByLeCHECK />
        </v-layout>
      </v-layout>
    </div>
    <v-form v-model="resetValid">
      <LabelDialog v-model="isPasswordResetDialogOpen">
        <template #dialog-title>
          パスワード再設定
        </template>

        <template #dialog-message
          >ログインID（メールアドレス）を入力し、送信ボタンを押してください。 <br />パスワード再登録用のリンクをお送りします。</template
        >

        <template #dialog-action>
          <v-layout column>
            <v-layout row>
              <EmailInput v-model="passwordResetMailAddress" v-on:keyup.enter.native="resetValid ? submitResetPassRequest() : false" />
              <Button
                width="100"
                primary
                :disabled="!passwordResetMailAddress"
                :loading="isSending"
                @click.native="submitResetPassRequest()"
                >送信
              </Button>
            </v-layout>
            <v-layout justify-end>
              <Button width="100" @click.native="isPasswordResetDialogOpen = !isPasswordResetDialogOpen">キャンセル </Button>
            </v-layout>
          </v-layout>
        </template>
      </LabelDialog>
    </v-form>

    <LabelDialog v-model="isPasswordResetSentDialogOpen" :message-pre-wrap="false">
      <template #dialog-title>
        パスワード再設定メールをお送りしました
      </template>

      <template #dialog-message>
        ご入力いただいたメールアドレスにパスワード再設定用のリンクをお送りしました。
        <br />メール内のリンクからパスワードの再設定を行ってください。
      </template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" @click.native="isPasswordResetSentDialogOpen = !isPasswordResetSentDialogOpen">閉じる </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>

    <LabelDialog v-model="isAccountLockWarningDialogOpen" :message-pre-wrap="false" warning>
      <template #dialog-title>
        アカウントロック
      </template>

      <template #dialog-message>
        ただ今一時的にアカウントをロックしています。
        <br />20分ほど経ってから再度お試しください。
        <p class="mt-4">
          ご登録時のメールアドレスとパスワードをもう一度お確かめいただき、パスワードをお忘れの方は、パスワード再設定手続きを行ってください。
        </p>
      </template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" primary @click.native="isAccountLockWarningDialogOpen = !isAccountLockWarningDialogOpen">閉じる </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>

    <LabelDialog v-model="isAccountLockDialogOpen" :message-pre-wrap="false" error>
      <template #dialog-title>
        アカウントロック
      </template>

      <template #dialog-message>
        ログインの失敗が一定数に達したため、アカウントをロックしました。
        <br />アカウント復旧についてのお問い合わせは、以下のフォームからお願いいたします。
        <a href="https://form.cloudsign.jp/s/contact-cloudsignreview" target="_blank"
          >https://form.cloudsign.jp/s/contact-cloudsignreview</a
        >
      </template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" primary @click.native="isAccountLockDialogOpen = !isAccountLockDialogOpen">閉じる </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>
  </v-container>
</template>

<script>
import { VAlert } from 'vuetify/lib';

// API
import AccountScenario from '@/api/account/scenario.js';
import PublicJsonQuery from '@/api/public_json/query.js';
import UrlQuery from '@/api/url/query.js';

import WarningText from '@/components/_atoms/WarningText.vue';

import LinkLabel from '@/components/_atoms/labels/LinkLabel.vue';
import Button from '@/components/_atoms/buttons/Button.vue';
import EmailInput from '@/components/_atoms/inputs/EmailInput.vue';
import LabelDialog from '@/components/_molecules/LabelDialog.vue';
import LabelEmailInput from '@/components/_molecules/LabelEmailInput.vue';
import LabelPasswordInput from '@/components/_molecules/LabelPasswordInput.vue';
import PoweredByLeCHECK from '@/components/_molecules/PoweredByLeCHECK';
import Announcement from '@/components/_organisms/Announcement.vue';

import errormsg from '@/constants/errormsg';

export default {
  name: 'LoginForCloudsignReview',
  components: {
    VAlert,
    WarningText,
    LabelEmailInput,
    LabelPasswordInput,
    LinkLabel,
    Button,
    LabelDialog,
    EmailInput,
    Announcement,
    PoweredByLeCHECK
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      loginLoading: false,
      resetValid: false,
      isPasswordResetDialogOpen: false,
      isSending: false,
      passwordResetMailAddress: '',
      accountLockValid: false,
      isPasswordResetSentDialogOpen: false,
      isAccountLockWarningDialogOpen: false,
      isAccountLockDialogOpen: false,
      browserEnvironmentAlert: errormsg.BROWSER_ENV_ALERT,
      announcementData: {
        show: false,
        items: []
      },
      redirect: this.$route.query.redirect ? this.$route.query.redirect : null,
      page: this.$route.query.page ? this.$route.query.page : null,
      router: '/contract_list'
    };
  },
  mounted() {
    this.init();
  },
  beforeMount() {
    this.redirectToContractListPageIfLoggedIn();
  },
  computed: {
    isAllowedBrowserAccess: function() {
      return this.$store.getters['userAgent/getIsAllowedBrowserAccess'];
    },
    valid: function() {
      return this.email && this.password;
    }
  },
  methods: {
    init() {
      PublicJsonQuery.getAnnouncement().then(res => {
        this.announcementData = res;
      });
    },
    redirectToContractListPageIfLoggedIn() {
      if (localStorage.getItem('refresh')) {
        this.$store
          .dispatch('auth/tryLoggedIn')
          .then(() => {
            this.$store.dispatch('auth/updateUserInfo');
            this.$router.push('/contract_list');
          })
          .catch(() => {
            this.$store.dispatch('auth/logout');
          });
      }
    },
    passwordReset() {
      this.passwordResetMailAddress = '';
      this.isPasswordResetDialogOpen = true;
    },
    async submitLogin() {
      if (!this.valid) return;

      this.loginLoading = true;

      this.$store
        .dispatch('auth/login', [this.email, this.password])
        .then(_ => {
          // ディスプレイ情報の保存
          this.$store.dispatch('userMetaLog/createUserMetaLog', {
            email: this.email,
            api_name: 'login'
          });
          if (this.redirect != null) {
            if (this.redirect.includes('review_contract')) {
              this.router = this.redirect;
            } else if (this.redirect.includes('help_center')) {
              this.checkHelpCenterUrl();
            }
            this.$router.push(this.router);
          } else {
            this.checkHelpCenterUrl();
          }
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.data.message === 'AccountLock') {
            this.isAccountLockWarningDialogOpen = true;
          } else if (error.response.status === 418) {
            this.isAccountLockDialogOpen = true;
          } else {
            this.$store.dispatch('message/setErrorMessage', {
              message: error.response.data.error ? error.response.data.error : 'ログインに失敗しました'
            });
          }
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
    checkHelpCenterUrl() {
      if (this.page != null) {
        UrlQuery.checkUrlValue(this.page)
          .then(_ => {
            this.router = { name: 'HelpCenter', query: { page: this.page } };
          })
          .catch(_ => {
            this.$store.dispatch('message/clearMessages');
          })
          .finally(_ => {
            this.$router.push(this.router);
          });
      } else {
        this.$router.push(this.router);
      }
    },
    submitResetPassRequest() {
      if (!this.passwordResetMailAddress) return;
      this.isSending = true;
      AccountScenario.sendPasswordResetMail(this.passwordResetMailAddress)
        .then(_ => {
          this.isPasswordResetSentDialogOpen = true;
        })
        .catch(error => {
          this.$store.dispatch('message/setSystemErrorMessage', {
            message: error.response.data.error ? error.response.data.error : 'パスワード再設定メールの送信に失敗しました。'
          });
        })
        .finally(() => {
          this.isSending = false;
          this.isPasswordResetDialogOpen = false;
        });
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  display: none;
}

.content-area {
  position: absolute;
  left: 50%;
  top: calc(50% - 50px);
  transform: translate(-50%, -50%);
}

/* Form */
.login-form-area {
  width: 426px;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #ced6e0;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}
.v-alert.v-alert {
  border: none !important;
  margin-bottom: 25px;
}

.login-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginForCloudsignReview.vue